import { Button } from '@abm-international/react-components';
import React from 'react';

interface ConfirmDialogProps {
    open: boolean;
    title?: string;
    message: string | React.ReactNode;
    confirmLabel?: string;
    cancelLabel?: string;
    onConfirm: () => void;
    onCancel: () => void;
}

export const ConfirmDialog: React.FC<ConfirmDialogProps> = ({
	open,
	title,
	message,
	confirmLabel = 'Bevestigen',
	cancelLabel = 'Annuleren',
	onConfirm,
	onCancel,
}) => {
	if (!open) return null;

	return (
		<div
			style={{
				position: 'fixed',
				top: 0,
				left: 0,
				width: '100vw',
				height: '100vh',
				background: 'rgba(0,0,0,0.3)',
				display: 'flex',
				alignItems: 'center',
				justifyContent: 'center',
				zIndex: 1000,
				fontSize: '12px',
			}}>
			<div
				style={{
					background: '#fff',
					padding: 20,
					borderRadius: 8,
					boxShadow: '0 2px 16px rgba(0,0,0,0.15)',
					maxWidth: 350,
					textAlign: 'center',
				}}>
				{title && <div style={{ fontWeight: 'bold', marginBottom: 8 }}>{title}</div>}
				<div style={{ marginBottom: 16 }}>{message}</div>
				<Button
					color="green"
					style={{ marginRight: 8 }}
					onClick={onConfirm}
				>
					{confirmLabel}
				</Button>
				<Button
					color="red"
					onClick={onCancel}
				>
					{cancelLabel}
				</Button>
			</div>
		</div>
	);
};
